/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CustomersImportFormat {
    EXCEL = 'Excel',
}
